import React from 'react'

export default () => 
<div>
    <br/>
<h3>1. PARTER OCH TJÄNSTER</h3>
Detta avtal är upprättat mellan Onestop och användaren. Systemet kallas för Tjänsten och
detta avtal kallas för Avtalet.
<h3>2. AVTALSTID</h3>
Så snart Användaren har beställt Tjänsten börjar Avtalet att löpa. Avtalstiden är samma
period som betalningsperioden. Avtalet förlängs automatiskt med samma period om
Tjänsten inte skriftligen har sagts upp senast en månad före avtalstidens utgång.
<h3>3. ANVÄNDARENS ÅTAGANDEN</h3>
3.1 Kostnader. Tjänstens fasta avgifter faktureras månadsvis i förskott eller årsvis beroende
av Användarens önskemål. Betalningsvillkor är 20 dagar netto. Vid uppsägning sker ingen
återbetalning av redan inbetald avgift. Kostnad för köpt media faktureras i samband med
beställning och betalningstiden är 20 dagar netto.
3.2 Avtalet medför inte att upphovsrätt eller andra immateriella rättigheter till Tjänsten
överlåts till Användaren. Användaren får inte kopiera, ändra eller på annat sätt hantera
programvara eller annat material som hör till Tjänsten, inte heller överlåta eller upplåta rätt
till sådan programvara eller material till annan, om det inte skriftligen har avtalats med
Onestop.
3.3 Användaren är skyldig att ange korrekt information om sitt företag och dess
organisationsnummer när registrering som Användare sker hos Onestop. Användaren är
ansvarig för att lösenord förvaras på ett säkert sätt. Användaren ansvarar själv för eventuellt
obehörigt utnyttjande av tjänsten. Användaren kan begära att Onestop spärrar Tjänsten eller
att Användaren får nytt lösenord.
3.4 Användaren är införstådd med att Tjänsten endast får användas för lagliga ändamål och
Användaren åtar sig att hålla Onestop skadeslös avseende samtliga krav från tredje man som
riktas mot Onestop med anledning av Användarens användning av Tjänsten, innefattande
men inte begränsat till anspråk avseende intrång i tredje parts immateriella rättigheter.
3.5 Användaren är ansvarig för att upphovsrätten, personuppgiftslagen och andra svenska
lagar och förordningar följs.
3.6 Användaren ansvarar för att tredjepartsprogram såsom webbläsare, pdf-läsare, toolbars,
antivirusprogram samt brandväggar är korrekt installerade och tillåter trafik mot av Onestop
hänvisade webbplatser.
<h3>4. ÅTAGANDEN ONESTOP</h3>

Onestop åtar sig att tillhandahålla Tjänsten till Användaren 24 timmar per dygn, med
undantag för planerade driftstopp, med de begränsningar som följande servicenivåer
innebär.
Onestop skall hålla tillgängligheten avseende Tjänsten på 99.5% eller högre. Om
tillgänglighetstalet under avtalstiden är under 99.5% under Servicetid, kan användaren
begära Vite om 10% av avgiften. Tillgänglighetstal understigande 90%) är att betrakta som
väsentligt avtalsbrott och ger Användaren rätt att säga upp Avtalet med omedelbar verkan.
4.1 Support
Support lämnas avseende systemspecifika frågor. Frågor avseende medierådgivning ingår ej i
supporten. Support lämnas via e-post support@onestopmedia.se
<h3>7. ANSVARSFRIHET FÖR ONESTOP</h3>
Onestop ansvarar inte för bristande uppfyllelse av avtalad servicenivå, om Onestop kan visa
att detta har orsakats av någon av nedanstående omständigheter och under förutsättning
att sådan omständighet inte är direkt hänförlig till Onestop:
 Fel i Användarens utrustning eller programvara
 Virus eller annat angrepp på säkerheten hos Användaren
 Omständighet utanför Onestop ansvarsområde för Tjänsten som t.ex. brist i
kommunikation eller andra produkter eller tjänster från tredje part som Onestop inte
uttryckligen har ansvar för.
 DoS-attacker
 Force majeure som betyder att Onestop inte är skyldigt att utge ersättning för förlust
eller skada som Användaren kan komma att lida till följd av att fullgörandet av
Onestop åtaganden förhindrats eller väsentligen försvårats av omständigheter som
Onestop inte rimligen kunnat råda över eller förutse, inklusive men inte begränsade
till arbetskonflikt, krig, uppror eller upplopp, mobilisering eller oförutsedda
militärinkallelser, rekvisition, beslag, valutarestriktioner, export- eller
importrestriktioner, jordbävning, blixtnedslag, eldsvåda, översvämning eller
vattenskada, allmän varuknapphet eller knapphet i fråga om transportmedel,
lagstiftning och myndighetsrestriktioner.
<h3>8. FEL I TJÄNSTEN</h3>
8.1 För den händelse det föreligger ett fel i Tjänsten så att bearbetningen av Användarens
Data föranleder ett felaktigt resultat, åtar sig Onestop, att så snart omständigheterna kräver
med hänsyn till felets art och omständigheterna i övrigt, att på egen bekostnad göra en ny
bearbetning av Användarens data.
8.2 Onestop ansvar enligt punkten 8.1 ovan gäller endast under förutsättning att: (i)
Användaren har levt upp till samtliga de åtaganden som anges i punkten 3 ovan; (ii) felet i
Tjänsten reklameras till Onestop av användaren inom trettio (30) dagar efter det att
Användaren upptäckt eller bort upptäcka felet; samt (iii) Användaren tillhandahåller
Onestop de data som är nödvändiga för Onestop bearbetning enligt punkten 8.1 ovan.
<h3>9. ANVÄNDARENS DATA</h3>

9.3 Har avtalet upphört på grund av utebliven betalning, lagras Användarens Data i maximalt
30 dagar varefter Onestop äger rätt att radera kundens kvarvarande material från Onestop
servrar.
9.4 Onestop ansvar för Användarens Data är begränsat till vad som framgår av punkten 8
ovan.
<h3>10. DATASÄKERHET</h3>
10.1 Autentisering och kryptering
 All datakommunikation sker med Secure Sockets Layer (SSL). För att få tillgång till
Tjänsten krävs inloggning med användarnamn, databasnamn och lösenord.
 Krypterad kommunikation: Onestop använder 256-bitars SSL-kryptering och 2048-
bitars publika nycklar från RSA. All datakommunikation till och från Användarens
datorer krypteras med SSL, den mest använda Internetstandarden för krypterad
kommunikation.
 Lösenordsskydd: Inloggningsförfarandet är helt krypterat, vilket innebär att ingen
information skickas som okrypterad text. Användarens lösenord lagras i
envägskrypterat format (med ett standardiserat envägschiffer).
<h3>11. ANSVARSBEGRÄNSNING</h3>
Onestop ansvar är begränsat till direkt skada om maximalt ett prisbasbelopp enligt 2 kap. 6 §
socialförsäkringsbalken. Onestop är aldrig ansvarigt för indirekt skador, såsom förlorad vinst
eller produktion, förlust av data etc. För att krav ska kunna göras gällande måste det
framställas inom två (2) månader från att skadan upptäckts eller borde ha upptäckts.
Onestop ansvarar inte för att tolkning av leverantörsfakturor blir korrekt, utan Användaren
ansvarar själv för slutlig kontroll

</div>


// WEBPACK FOOTER //
// ./src/components/Auth/Tos.js